import React from 'react';
import { BsGithub } from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    <a href="https://github.com/Aseem5047" target="_blank"
      rel="noopener noreferrer">
      <BsGithub />
    </a>
  </div>
);

export default SocialMedia;